import type { FilterGroup } from '@jane/bloom/viewModels/productSearchFilters';

export const isRootCategoryFilterGroup = ({
  filterKey,
  filterValues,
}: FilterGroup) =>
  filterKey === 'categories' &&
  !filterValues.some((value) => value.includes(':'));
